import axiosInstance from "./axiosInstance";

const fetchServices = async (
  serviceUrl,
  method = "GET",
  requestBody = null,
  authToken = null,
) => {
  try {
    const options = {
      url: serviceUrl,
      method,
      data: requestBody,
      headers: {},
    };
    
    if (requestBody && requestBody instanceof FormData){
        options.headers["Content-Type"] = "multipart/form-data";
    }
    
    const response = await axiosInstance(options);
    return response.data;
  } catch (err) {
    if (err.response) {
      return err.response.data;
    } else {
      return {
        status_code: 500,
        data: { message: err.message || "Unexpected error" },
      };
    }
  }
};

export default fetchServices;
